module.exports = __webpack_public_path__ + "img/Field-Level-Endzone-BG.23351fb3.jpg";